// The bottom-center text overlay was removed per user request.
// The diagonal tiled watermark is rendered as an SVG overlay in UploadFlow.
// This function is kept as a no-op passthrough for backwards compatibility.
export async function addWatermark(src: string, _text = "PunchInk.com"): Promise<string> {
  return src;
}
